/**
 * DİL SEÇİCİ — her sayfanın üst çubuğunda (kullanıcı kararı 28.10.2026).
 *
 * Kasa açılmadan önce de görünür (tanıtım, kurulum, kilit): Türkçe dışı bir
 * tarayıcıdan gelen ziyaretçi otomatik İngilizceyi görür, isterse buradan
 * değiştirir. Diller kendi adlarıyla; seçim yalnızca cihazda kalır ve sayfayı
 * yeniden yükler (`dilDegistir`). Ayarlar › Görünüm'deki seçiciyle aynı tercih.
 */

import { DIL, DILLER, M, dilDegistir, type DilKodu } from "../dil";
import { cx } from "../ui/primitives";

export function DilSecici({ kip = "normal" }: { readonly kip?: "normal" | "hero" }) {
  return (
    <label
      className={cx(
        "inline-flex shrink-0 items-center gap-1 rounded-pf border px-1.5 py-0.5 text-[12px] focus-within:ring-2 focus-within:ring-accent",
        kip === "hero" ? "border-white/40 text-hero-fg" : "border-line text-muted",
      )}
    >
      <svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="7.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M2.5 10h15M10 2.5c2.2 2.3 3.2 4.8 3.2 7.5s-1 5.2-3.2 7.5M10 2.5C7.8 4.8 6.8 7.3 6.8 10s1 5.2 3.2 7.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
      <select
        aria-label={M.ayarlar.gorunum.dil}
        data-dil-secici=""
        value={DIL}
        onChange={(e) => dilDegistir(e.currentTarget.value as DilKodu)}
        className={cx(
          "cursor-pointer appearance-none bg-transparent pr-0.5 outline-none",
          kip === "hero" ? "text-hero-fg [&>option]:text-ink" : "text-ink",
        )}
      >
        {DILLER.map((d) => (
          <option key={d.kod} value={d.kod} lang={d.kod}>
            {d.ad}
          </option>
        ))}
      </select>
    </label>
  );
}
